var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85226 0.485719L13.5143 4.14774C14.1619 4.79536 14.1619 5.84537 13.5143 6.493L7.11542 12.8909L11.6098 12.891C11.8897 12.891 12.121 13.099 12.1576 13.3688L12.1626 13.4438C12.1626 13.7237 11.9546 13.9549 11.6848 13.9916L11.6098 13.9966L5.41128 13.9975C4.9571 14.0223 4.49468 13.8612 4.14774 13.5143L0.485719 9.85226C-0.161906 9.20464 -0.161906 8.15463 0.485719 7.507L7.507 0.485719C8.15463 -0.161906 9.20464 -0.161906 9.85226 0.485719ZM6.77715 11.6073L2.38827 7.21844L1.27804 8.29932C1.06216 8.5152 1.06216 8.8652 1.27804 9.08107L4.92328 12.7262C5.14253 12.9387 5.49249 12.9331 5.70493 12.7139L6.77715 11.6073Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraseIcon);
export default __webpack_public_path__ + "static/media/erase_icon.c3f825ddacae04af157f0ae69f678da7.svg";
export { ForwardRef as ReactComponent };